(function () {
  'use strict';

  var STORAGE_KEY = 'canadian-cutters-micro-basket-v1';
  var BUILDER_VERSION = '1';
  var FAMILY_RULES = [
    ['Aquatic', /splash|aquatic|sea |ocean|shark|whale|dolphin|starfish|lobster|narwhal|frog|platypus|catfish|crocodile/i],
    ['Farm', /farm|cow|chicken|horse|pig|goat|llama|turkey|rooster|chick/i],
    ['Forest', /forest|fox|beaver|bunny|hedgehog|panda|koala|reindeer/i],
    ['Pets', /pet|cat|dog|pug|bunny/i],
    ['Prehistoric', /prehistoric|dinosaur|triceratops|steg|brachio|t-rex/i],
    ['Safari', /safari|lion|elephant|giraffe|hippo|rhino|rhinoceros|capybara/i],
    ['Bugs & Critters', /bug|critter|bee|beetle|spider|caterpillar/i],
    ['Spooky & Seasonal', /haunted|spooky|zombie|mummy|skeleton|santa|snowman|gingerbread|christmas|easter|reindeer/i],
  ];

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function cleanList(value) {
    return String(value || '').split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean);
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    return String(tags || '').split(',').map(function (tag) { return tag.trim(); });
  }

  function getFamilies(product) {
    var source = [product.title, product.handle].concat(normalizeTags(product.tags)).join(' ');
    var families = FAMILY_RULES.filter(function (rule) {
      return rule[1].test(source);
    }).map(function (rule) { return rule[0]; });
    return families.length ? families : ['More Micros'];
  }

  function optimizedImageUrl(image) {
    var url = image && (image.src || image) || '';
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=360';
  }

  function imageUrls(product) {
    return (product.images || []).map(optimizedImageUrl).filter(Boolean);
  }

  function normalizeProduct(product, index) {
    return {
      id: String(product.id),
      handle: product.handle,
      title: product.title.replace(/^Adorable |^Charming |^Delightful |^Enchanting |^Majestic |^Our |^Sleek /i, ''),
      fullTitle: product.title,
      image: imageUrls(product)[0] || '',
      images: imageUrls(product),
      tags: normalizeTags(product.tags),
      families: getFamilies(product),
      rank: index,
      variants: (product.variants || []).filter(function (variant) {
        return variant.available !== false;
      }).map(function (variant) {
        return {
          id: Number(variant.id),
          title: variant.title || 'Default Title',
          available: variant.available !== false,
        };
      }),
    };
  }

  function loadBasket() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return parsed && parsed.version === 1 && Array.isArray(parsed.items) ? parsed : { version: 1, items: [] };
    } catch (error) {
      return { version: 1, items: [] };
    }
  }

  function saveBasket(basket) {
    basket.updatedAt = new Date().toISOString();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(basket)); } catch (error) {}
  }

  function bundleId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'micro-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function init(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var collectionHandle = root.dataset.collectionHandle || 'micro-minis';
    var excluded = cleanList(root.dataset.excludedHandles);
    var extraHandles = cleanList(root.dataset.extraHandles);
    var prices = {
      base: Number(root.dataset.basePrice) || 300,
      tier10: Number(root.dataset.tier10) || 250,
      tier50: Number(root.dataset.tier50) || 200,
      tier100: Number(root.dataset.tier100) || 150,
    };
    var basket = loadBasket();
    var cartConnectionEnabled = root.dataset.cartConnectionEnabled === 'true';
    var urlParams = new URLSearchParams(window.location.search);
    var editingBundleId = urlParams.get('edit_bundle') || '';
    var highlightedHandle = urlParams.get('micro') || '';
    var cartState = { items: [], total_price: 0 };
    var existingMicroCount = 0;
    var nonMicroSubtotal = 0;
    var detailsOpen = false;
    var products = [];
    var activeFamily = 'All';
    var query = '';
    var sort = 'featured';

    var grid = root.querySelector('[data-micro-grid]');
    var status = root.querySelector('[data-micro-status]');
    var familySelect = root.querySelector('[data-micro-family]');
    var template = root.querySelector('[data-micro-card-template]');
    var basketPanel = root.querySelector('[data-micro-basket]');
    var basketItems = root.querySelector('[data-micro-basket-items]');
    var confirmButton = root.querySelector('[data-micro-confirm]');
    var checkoutError = root.querySelector('[data-micro-checkout-error]');
    var basketNote = root.querySelector('[data-micro-basket-note]');

    function quantity() {
      return basket.items.reduce(function (total, item) { return total + item.quantity; }, 0);
    }

    function projectedMicroCount() {
      return existingMicroCount + quantity();
    }

    function projectedSubtotal() {
      return nonMicroSubtotal + projectedMicroCount() * unitPrice(projectedMicroCount());
    }

    function unitPrice(count) {
      if (count >= 100) return prices.tier100;
      if (count >= 50) return prices.tier50;
      if (count >= 10) return prices.tier10;
      return prices.base;
    }

    function findBasketItem(variantId) {
      return basket.items.find(function (item) { return item.variantId === variantId; });
    }

    function setQuantity(product, variantId, nextQuantity) {
      var item = findBasketItem(variantId);
      if (nextQuantity <= 0) {
        basket.items = basket.items.filter(function (entry) { return entry.variantId !== variantId; });
      } else if (item) {
        item.quantity = Math.min(50, nextQuantity);
      } else {
        var variant = product.variants.find(function (entry) { return entry.id === variantId; });
        basket.items.push({
          productId: product.id,
          variantId: variantId,
          handle: product.handle,
          title: product.title,
          variantTitle: variant ? variant.title : 'Default Title',
          image: product.image,
          quantity: Math.min(50, nextQuantity),
          families: product.families,
        });
      }
      saveBasket(basket);
      refreshCards();
      renderBasket();
    }

    function progressMessage(count) {
      var milestones = [10, 50, 100];
      var next = milestones.find(function (milestone) { return count < milestone; });
      if (!count) return { text: 'Add your favourites to begin.', percent: 0 };
      if (!next) return { text: 'Top collector price unlocked — $1.50 each.', percent: 100 };
      var previous = next === 10 ? 0 : next === 50 ? 10 : 50;
      var nextPrice = next === 10 ? prices.tier10 : next === 50 ? prices.tier50 : prices.tier100;
      return {
        text: 'Add ' + (next - count) + ' more to unlock ' + money(nextPrice) + ' each.',
        percent: Math.max(4, ((count - previous) / (next - previous)) * 100),
      };
    }

    function renderBasket() {
      var count = quantity();
      var combinedCount = projectedMicroCount();
      var price = unitPrice(combinedCount);
      var total = count * price;
      var savings = count * prices.base - total;
      var progress = progressMessage(combinedCount);
      var minimumRemaining = Math.max(0, 1000 - projectedSubtotal());
      if (existingMicroCount > 0) {
        progress.text = existingMicroCount + ' Micro' + (existingMicroCount === 1 ? '' : 's') + ' already in your cart. ' + progress.text;
      }
      root.querySelectorAll('[data-micro-count]').forEach(function (node) { node.textContent = count; });
      root.querySelector('[data-micro-launch-count]').textContent = count;
      root.querySelector('[data-micro-unit-price]').textContent = money(price) + ' each';
      root.querySelector('[data-micro-total]').textContent = money(total);
      root.querySelector('[data-micro-launch-total]').textContent = money(total);
      root.querySelector('[data-micro-progress-copy]').textContent = progress.text;
      root.querySelector('[data-micro-progress]').style.width = progress.percent + '%';
      root.querySelector('[data-micro-clear]').disabled = count === 0;
      confirmButton.disabled = count === 0 || minimumRemaining > 0 || !cartConnectionEnabled;
      confirmButton.textContent = cartConnectionEnabled
        ? (editingBundleId ? 'Update collection in cart' : 'Add collection to cart')
        : 'Checkout connection awaiting tier pricing';
      basketNote.textContent = minimumRemaining > 0 && count > 0
        ? 'Add ' + money(minimumRemaining) + ' more in merchandise before checkout.'
        : cartConnectionEnabled
        ? (editingBundleId ? 'Saving will update this collection in your Shopify cart.' : 'Your collection will be added to your Shopify cart as individual Micros.')
        : 'Your Micro Basket is saved on this device. Shopify tier pricing must be enabled before checkout.';
      var savingsNode = root.querySelector('[data-micro-savings]');
      savingsNode.hidden = savings <= 0;
      savingsNode.querySelector('strong').textContent = money(savings);
      var detailsToggle = root.querySelector('[data-micro-details-toggle]');
      var detailsLabel = root.querySelector('[data-micro-details-label]');
      var summaryImages = root.querySelector('[data-micro-summary-images]');
      detailsToggle.disabled = count === 0;
      detailsToggle.setAttribute('aria-expanded', String(detailsOpen));
      detailsLabel.textContent = detailsOpen ? 'Hide details' : 'View details';
      basketItems.hidden = !detailsOpen;

      if (!basket.items.length) {
        detailsOpen = false;
        detailsToggle.setAttribute('aria-expanded', 'false');
        detailsLabel.textContent = 'View details';
        basketItems.hidden = true;
        summaryImages.innerHTML = '<span>Your selected Micros will appear here.</span>';
        basketItems.innerHTML = '<div class="micro-basket__empty">Your collection is waiting. Add a Micro from the catalogue.</div>';
        return;
      }

      summaryImages.innerHTML = '';
      basket.items.slice(0, 5).forEach(function (item) {
        var summaryImage = document.createElement('img');
        summaryImage.src = item.image;
        summaryImage.alt = item.title;
        summaryImage.width = 38;
        summaryImage.height = 38;
        summaryImages.appendChild(summaryImage);
      });
      if (basket.items.length > 5) {
        var remaining = document.createElement('span');
        remaining.className = 'micro-basket__summary-more';
        remaining.textContent = '+' + (basket.items.length - 5);
        summaryImages.appendChild(remaining);
      }

      basketItems.innerHTML = '';
      basket.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'micro-basket-item';
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 50;
        image.height = 50;

        var description = document.createElement('div');
        var title = document.createElement('h3');
        title.textContent = item.title;
        description.appendChild(title);
        if (item.variantTitle && item.variantTitle !== 'Default Title') {
          var variant = document.createElement('p');
          variant.textContent = item.variantTitle;
          description.appendChild(variant);
        }

        var controls = document.createElement('div');
        controls.className = 'micro-basket-item__controls';
        var decrease = document.createElement('button');
        decrease.type = 'button';
        decrease.dataset.minus = '';
        decrease.setAttribute('aria-label', 'Remove one');
        decrease.textContent = '−';
        var quantityValue = document.createElement('span');
        quantityValue.textContent = item.quantity;
        var increase = document.createElement('button');
        increase.type = 'button';
        increase.dataset.plus = '';
        increase.setAttribute('aria-label', 'Add one');
        increase.textContent = '+';
        controls.append(decrease, quantityValue, increase);
        row.append(image, description, controls);

        decrease.addEventListener('click', function () {
          var product = products.find(function (entry) { return entry.id === item.productId; });
          if (product) setQuantity(product, item.variantId, item.quantity - 1);
        });
        increase.addEventListener('click', function () {
          var product = products.find(function (entry) { return entry.id === item.productId; });
          if (product) setQuantity(product, item.variantId, item.quantity + 1);
        });
        basketItems.appendChild(row);
      });
    }

    function populateFamilies() {
      var families = ['All'];
      products.forEach(function (product) {
        product.families.forEach(function (family) {
          if (families.indexOf(family) === -1) families.push(family);
        });
      });
      familySelect.innerHTML = '';
      families.forEach(function (family) {
        var option = document.createElement('option');
        option.value = family;
        option.textContent = family === 'All' ? 'All Micros' : family;
        familySelect.appendChild(option);
      });
    }

    function refreshCards() {
      grid.querySelectorAll('.micro-card').forEach(function (card) {
        if (typeof card.updateMicroState === 'function') card.updateMicroState();
      });
    }

    function cartItemBundleId(item) {
      return item && item.properties && item.properties._micro_bundle_id || '';
    }

    function hydrateCartContext(cart) {
      cartState = cart && Array.isArray(cart.items) ? cart : { items: [], total_price: 0 };
      var microVariantIds = new Set();
      products.forEach(function (product) {
        product.variants.forEach(function (variant) { microVariantIds.add(variant.id); });
      });

      existingMicroCount = 0;
      nonMicroSubtotal = 0;
      cartState.items.forEach(function (item) {
        var isMicro = microVariantIds.has(Number(item.variant_id));
        if (!isMicro) {
          nonMicroSubtotal += Number(item.final_line_price || item.line_price || 0);
        } else if (!editingBundleId || cartItemBundleId(item) !== editingBundleId) {
          existingMicroCount += Number(item.quantity || 0);
        }
      });

      if (!editingBundleId) return;
      var bundleLines = cartState.items.filter(function (item) {
        return cartItemBundleId(item) === editingBundleId;
      });
      if (!bundleLines.length) {
        editingBundleId = '';
        checkoutError.hidden = false;
        checkoutError.textContent = 'That saved Micro collection is no longer in your cart. Start a new collection below.';
        return;
      }

      var unavailableLine = bundleLines.some(function (line) {
        return !products.some(function (product) {
          return product.variants.some(function (variant) { return variant.id === Number(line.variant_id); });
        });
      });
      if (unavailableLine) {
        var unavailableError = new Error('Unavailable Micro in saved collection');
        unavailableError.customerMessage = 'One or more Micros in this collection could not be loaded or are no longer available. Your cart has not been changed. Return to your cart to review the collection before editing it.';
        throw unavailableError;
      }

      basket.items = bundleLines.map(function (line) {
        var product = products.find(function (entry) {
          return entry.variants.some(function (variant) { return variant.id === Number(line.variant_id); });
        });
        var variant = product && product.variants.find(function (entry) { return entry.id === Number(line.variant_id); });
        if (!product || !variant) return null;
        return {
          productId: product.id,
          variantId: variant.id,
          handle: product.handle,
          title: product.title,
          variantTitle: variant.title,
          image: product.image,
          quantity: Number(line.quantity || 0),
          families: product.families,
        };
      }).filter(Boolean);
      saveBasket(basket);
    }

    function renderCards() {
      var visible = products.filter(function (product) {
        var matchesFamily = activeFamily === 'All' || product.families.indexOf(activeFamily) !== -1;
        var matchesQuery = !query || (product.title + ' ' + product.fullTitle + ' ' + product.families.join(' ')).toLowerCase().indexOf(query) !== -1;
        return matchesFamily && matchesQuery;
      });
      visible.sort(function (a, b) {
        if (sort === 'name') return a.title.localeCompare(b.title);
        if (sort === 'basket') {
          var aCount = a.variants.reduce(function (sum, variant) { var item = findBasketItem(variant.id); return sum + (item ? item.quantity : 0); }, 0);
          var bCount = b.variants.reduce(function (sum, variant) { var item = findBasketItem(variant.id); return sum + (item ? item.quantity : 0); }, 0);
          return bCount - aCount || a.title.localeCompare(b.title);
        }
        return a.rank - b.rank;
      });
      grid.innerHTML = '';
      status.textContent = '';
      root.querySelector('[data-micro-result-count]').textContent = visible.length + ' of ' + products.length + ' shown';

      visible.forEach(function (product) {
        var card = template.content.firstElementChild.cloneNode(true);
        var image = card.querySelector('.micro-card__image');
        var select = card.querySelector('.micro-card__variant select');
        var variantLabel = card.querySelector('.micro-card__variant');
        var picker = card.querySelector('.micro-card__picker');
        var pickerInput = picker.querySelector('input');
        var previousImage = card.querySelector('[data-gallery-previous]');
        var nextImage = card.querySelector('[data-gallery-next]');
        var imageCount = card.querySelector('[data-gallery-count]');
        var selectedId = product.variants[0] && product.variants[0].id;
        var imageIndex = 0;

        image.src = product.image;
        image.alt = product.fullTitle;
        card.querySelector('.micro-card__title').textContent = product.title;
        card.querySelector('.micro-card__family').textContent = product.families.join(' · ');

        function showImage(nextIndex) {
          imageIndex = (nextIndex + product.images.length) % product.images.length;
          image.src = product.images[imageIndex];
          image.alt = product.fullTitle + (product.images.length > 1 ? ', image ' + (imageIndex + 1) + ' of ' + product.images.length : '');
          imageCount.textContent = (imageIndex + 1) + ' / ' + product.images.length;
        }

        if (product.images.length > 1) {
          previousImage.hidden = false;
          nextImage.hidden = false;
          imageCount.hidden = false;
          previousImage.addEventListener('click', function () { showImage(imageIndex - 1); });
          nextImage.addEventListener('click', function () { showImage(imageIndex + 1); });
          showImage(0);
        }

        if (product.variants.length > 1) {
          variantLabel.hidden = false;
          product.variants.forEach(function (variant) {
            var option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.title;
            select.appendChild(option);
          });
          select.addEventListener('change', function () {
            selectedId = Number(select.value);
            updateCardState();
          });
        }

        function updateCardState() {
          var totalForProduct = product.variants.reduce(function (sum, variant) {
            var item = findBasketItem(variant.id);
            return sum + (item ? item.quantity : 0);
          }, 0);
          card.dataset.inBasket = String(totalForProduct > 0);
          var badge = card.querySelector('.micro-card__quantity');
          badge.hidden = totalForProduct === 0;
          badge.textContent = totalForProduct;
          var selectedItem = findBasketItem(selectedId);
          if (document.activeElement !== pickerInput) {
            pickerInput.value = selectedItem ? selectedItem.quantity : 0;
          }
        }

        function pickerValue() {
          var value = Math.round(Number(pickerInput.value) || 0);
          return Math.max(0, Math.min(50, value));
        }
        picker.querySelector('[data-picker-action="decrease"]').addEventListener('click', function () {
          var item = findBasketItem(selectedId);
          setQuantity(product, selectedId, Math.max(0, (item ? item.quantity : 0) - 1));
        });
        picker.querySelector('[data-picker-action="increase"]').addEventListener('click', function () {
          var item = findBasketItem(selectedId);
          setQuantity(product, selectedId, Math.min(50, (item ? item.quantity : 0) + 1));
        });
        pickerInput.addEventListener('change', function () {
          setQuantity(product, selectedId, pickerValue());
        });
        card.updateMicroState = updateCardState;
        updateCardState();
        grid.appendChild(card);
      });
    }

    function render() {
      populateFamilies();
      renderCards();
      renderBasket();
    }

    function openBasket(open) {
      root.dataset.basketOpen = String(open);
      document.documentElement.classList.toggle('micro-basket-is-open', open);
      syncBasketLayout();
      if (open) {
        window.requestAnimationFrame(function () {
          root.querySelector('[data-micro-close]').focus();
        });
      } else if (window.innerWidth < 990) {
        root.querySelector('[data-micro-open]').focus();
      }
    }

    function syncBasketLayout() {
      var mobile = window.innerWidth < 990;
      var open = root.dataset.basketOpen === 'true';
      basketPanel.inert = mobile && !open;
      if (mobile) {
        basketPanel.setAttribute('role', 'dialog');
        basketPanel.setAttribute('aria-modal', String(open));
        basketPanel.setAttribute('aria-hidden', String(!open));
      } else {
        basketPanel.removeAttribute('role');
        basketPanel.removeAttribute('aria-modal');
        basketPanel.removeAttribute('aria-hidden');
      }
    }
    window.addEventListener('resize', syncBasketLayout);

    root.querySelector('[data-micro-search]').addEventListener('input', function (event) {
      query = event.target.value.trim().toLowerCase();
      renderCards();
    });
    root.querySelector('[data-micro-sort]').addEventListener('change', function (event) {
      sort = event.target.value;
      renderCards();
    });
    familySelect.addEventListener('change', function (event) {
      activeFamily = event.target.value;
      renderCards();
    });
    var toolsToggle = root.querySelector('[data-micro-tools-toggle]');
    var toolsPanel = root.querySelector('[data-micro-tools-panel]');
    toolsToggle.addEventListener('click', function () {
      var open = toolsToggle.getAttribute('aria-expanded') !== 'true';
      toolsToggle.setAttribute('aria-expanded', String(open));
      toolsPanel.hidden = !open;
      if (open) root.querySelector('[data-micro-search]').focus();
    });
    root.querySelector('[data-micro-tools-clear]').addEventListener('click', function () {
      query = '';
      sort = 'featured';
      activeFamily = 'All';
      root.querySelector('[data-micro-search]').value = '';
      root.querySelector('[data-micro-sort]').value = sort;
      familySelect.value = activeFamily;
      renderCards();
    });
    root.querySelector('[data-micro-open]').addEventListener('click', function () { openBasket(true); });
    root.querySelector('[data-micro-close]').addEventListener('click', function () { openBasket(false); });
    root.querySelector('[data-micro-scrim]').addEventListener('click', function () { openBasket(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.dataset.basketOpen === 'true') openBasket(false);
    });
    root.querySelector('[data-micro-clear]').addEventListener('click', function () {
      if (basket.items.length && window.confirm('Clear every Micro from this basket?')) {
        basket.items = [];
        saveBasket(basket);
        render();
      }
    });
    root.querySelector('[data-micro-details-toggle]').addEventListener('click', function () {
      if (!basket.items.length) return;
      detailsOpen = !detailsOpen;
      renderBasket();
    });

    function cartRequest(path, body) {
      return fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Shopify could not update this collection.');
          return data;
        });
      });
    }

    function basketCartItems(id) {
      return basket.items.map(function (item) {
        return {
          id: item.variantId,
          quantity: item.quantity,
          properties: {
            '_micro_bundle_id': id,
            '_micro_builder_version': BUILDER_VERSION,
            '_micro_name': item.title,
          },
        };
      });
    }

    function updateExistingBundle(id) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) {
        if (!response.ok) throw new Error('Shopify could not load your cart.');
        return response.json();
      }).then(function (cart) {
        var existingVariantIds = new Set(cart.items.filter(function (item) {
          return cartItemBundleId(item) === id;
        }).map(function (item) { return Number(item.variant_id); }));
        var additions = basketCartItems(id).filter(function (item) { return !existingVariantIds.has(item.id); });
        return additions.length ? cartRequest('/cart/add.js', { items: additions }) : null;
      }).then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      }).then(function (response) {
        if (!response.ok) throw new Error('Shopify could not verify your cart.');
        return response.json();
      }).then(function (cart) {
        var desired = new Map(basket.items.map(function (item) { return [item.variantId, item.quantity]; }));
        var updates = {};
        cart.items.filter(function (item) { return cartItemBundleId(item) === id; }).forEach(function (item) {
          updates[item.key] = desired.get(Number(item.variant_id)) || 0;
        });
        return cartRequest('/cart/update.js', { updates: updates });
      });
    }

    confirmButton.addEventListener('click', function () {
      if (!cartConnectionEnabled || !basket.items.length || confirmButton.getAttribute('aria-busy') === 'true') return;

      var id = editingBundleId || bundleId();
      var originalLabel = confirmButton.textContent;
      checkoutError.hidden = true;
      checkoutError.textContent = '';
      confirmButton.disabled = true;
      confirmButton.setAttribute('aria-busy', 'true');
      confirmButton.textContent = 'Adding collection…';

      var saveRequest = editingBundleId
        ? updateExistingBundle(id)
        : cartRequest('/cart/add.js', { items: basketCartItems(id) });
      saveRequest.then(function () {
        basket.lastAddedBundleId = id;
        basket.items = [];
        saveBasket(basket);
        window.location.assign('/cart?micro_bundle=' + encodeURIComponent(id));
      }).catch(function (error) {
        checkoutError.textContent = error.message || 'Something went wrong. Please try again.';
        checkoutError.hidden = false;
        confirmButton.disabled = false;
        confirmButton.removeAttribute('aria-busy');
        confirmButton.textContent = originalLabel;
      });
    });
    syncBasketLayout();

    var collectionRequest = fetch('/collections/' + collectionHandle + '/products.json?limit=250').then(function (response) {
      if (!response.ok) throw new Error('Collection request failed');
      return response.json();
    }).then(function (data) { return data.products || []; });
    var extraRequests = extraHandles.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (response) {
        return response.ok ? response.json() : null;
      });
    });
    var existingCartRequest = fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).catch(function () {
      var cartError = new Error('Cart request failed');
      cartError.customerMessage = 'We could not load your cart. Please refresh before adding or editing a collection. Your saved Micro Basket has been kept.';
      throw cartError;
    });

    Promise.all([collectionRequest, Promise.all(extraRequests), existingCartRequest]).then(function (results) {
      var combined = results[0].concat(results[1].filter(Boolean));
      var seen = {};
      products = combined.filter(function (product) {
        if (!product || seen[product.handle] || excluded.indexOf(product.handle) !== -1) return false;
        seen[product.handle] = true;
        return true;
      }).map(normalizeProduct).filter(function (product) { return product.variants.length > 0; });
      basket.items = basket.items.filter(function (item) {
        return products.some(function (product) {
          return product.variants.some(function (variant) { return variant.id === item.variantId; });
        });
      });
      hydrateCartContext(results[2]);
      saveBasket(basket);
      render();
      if (highlightedHandle) {
        var highlightedProduct = products.find(function (product) { return product.handle === highlightedHandle; });
        if (highlightedProduct) {
          query = highlightedProduct.title.toLowerCase();
          root.querySelector('[data-micro-search]').value = highlightedProduct.title;
          renderCards();
        }
      }
    }).catch(function (error) {
      status.textContent = error.customerMessage || 'We could not load the Micros. Please refresh and try again.';
      status.setAttribute('role', 'alert');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-micro-builder]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
